import { createAction, props } from '@ngrx/store';
import { createPasswordType } from '../../core/models/Interfaces/createPassword';

export const resetPasswordRequest = createAction(
  'reset-password-request',
  props<{ createPasswordParams: createPasswordType }>(),
);

export const resetPasswordReceived = createAction(
  'reset-password-received',
  props<{ data: any }>(),
);

export const resetPasswordFailed = createAction(
  'reset-password-failed',
  props<{ error: any }>(),
);

export const resetPasswordState = createAction('reset-password-state');
